export default "__VITE_ASSET__CXiMN5UZ__"